import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function fileUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  if (path.startsWith("/api/")) return `${BACKEND_URL}${path}`;
  return `${API}/files/${path}`;
}

export const PLACEHOLDER =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23FDFBF7'/%3E%3Crect x='2' y='2' width='396' height='296' fill='none' stroke='%23111' stroke-width='4'/%3E%3Ctext x='50%25' y='50%25' font-family='monospace' font-size='20' fill='%23111' text-anchor='middle' dominant-baseline='middle'%3E放空 FANGKONG%3C/text%3E%3C/svg%3E";

export function img(path) {
  return fileUrl(path) || PLACEHOLDER;
}

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "出错了 / Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x?.msg ? x.msg : JSON.stringify(x))).join(" ");
  return String(detail);
}

export default api;
